<template>
  <div>
    <div
      v-for="(item, index) in resultData.data"
      :key="`search-result-item-${index}`"
      class="mb-3"
    >
      <callout
        ref="callout"
        :controlled="true"
        :disabled="showDetails(item.serviceName)"
        :has-toggle="true"
        :opened="item.isOpen"
        @click:open="openDetails({ item, index }, PANELS.ADDITIONAL_INFO)"
      >
        <div class="row">
          <div class="col-md-2 col-sm-12 border-right pr-3">
            <div class="mt-3 text-center">
              <custom-balloon
                :background-color="` bg-${getColorStatus(item.status)}`"
                class="w-md-90 w-100 m-0"
                :text="item.status.name"
              />
              <div class="mt-3 ml-3 text-left">
                <div
                  v-if="
                    item.generatedByClaimType == ByClaimType.Tarjeta &&
                      item.status.id != CardManagementStatus.SolicitadaBanco
                  "
                  class="data-label"
                >
                  <i class="far fa-credit-card mr-3" />
                  Tarjeta
                </div>
                <div
                  v-if="item.generatedByClaimType == ByClaimType.PIN"
                  class="data-label"
                >
                  <i class="fas fa-calculator mr-3" />
                  PIN
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-10 py-2 px-4">
            <div class="row">
              <div class="col-md-4">
                <div class="data-label">Estudiante:</div>
                <span class="data">
                  {{ item.numSIE }}-{{ getStudentFullName(item) }}
                </span>
              </div>

              <div class="col-sm pl-md-5">
                <div class="data-label">Fecha de Creación:</div>
                <span class="data">{{ item.createdDate | date }}</span>
              </div>
              <div class="col-sm col-md-3">
                <div class="data-label">Número de Secuencia:</div>
                <span class="data">{{ item.sequenceRegionNumber }}</span>
              </div>
              <div class="col-sm d-flex justify-content-end">
                <drop-down
                  class="mr-3"
                  :data-item="{ item, index }"
                  :items="actionItems(item)"
                />
              </div>
            </div>
          </div>
        </div>

        <template #edition>
          <div class=" p-2">
            <div class="bg-white rounded p-3">
              <div class="mb-3">
                <div>
                  <div class="col-md-12">
                    <claim-card
                      v-if="selectedOption == PANELS.CLAIM"
                      :id="item.id"
                      :bank-request-date="new Date(item.bankRequestDate)"
                      @on-cancel="toggleOpen(index)"
                      @on-saved="doSearch(index)"
                    />
                    <received-card
                      v-if="selectedOption == PANELS.RECEIVED"
                      :id="item.id"
                      :bank-request-date="new Date(item.bankRequestDate)"
                      :claim-by-pin="isClaimByPin(item)"
                      @on-cancel="toggleOpen(index)"
                      @on-saved="doSearch(index)"
                    />
                    <single-received-card
                      v-if="selectedOption == PANELS.SINGLE_RECEIVED"
                      :id="item.id"
                      :bank-request-date="new Date(item.bankRequestDate)"
                      :title="singleReceivedLabel(item.status)"
                      @on-cancel="toggleOpen(index)"
                      @on-saved="doSearch(index)"
                    />
                    <deliver-card
                      v-if="selectedOption == PANELS.DELIVER"
                      :id="item.id"
                      :bank-request-date="new Date(item.bankRequestDate)"
                      @on-cancel="toggleOpen(index)"
                      @on-saved="doSearch(index)"
                    />
                    <archive-card
                      v-if="selectedOption == PANELS.ARCHIVE"
                      :id="item.id"
                      @on-cancel="toggleOpen(index)"
                      @on-saved="doSearch(index)"
                    />
                    <cancel-card
                      v-if="selectedOption == PANELS.CANCEL"
                      :id="item.id"
                      @on-cancel="toggleOpen(index)"
                      @on-saved="doSearch(index)"
                    />
                    <card-management
                      v-if="selectedOption == PANELS.MANAGEMENT"
                      :id="item.id"
                      :bank-request-date="new Date(item.bankRequestDate)"
                      @on-cancel="toggleOpen(index)"
                      @on-saved="doSearch(index)"
                    />
                    <document-card
                      v-if="selectedOption == PANELS.DOCUMENTS"
                      :id="item.id"
                      @on-cancel="toggleOpen(index)"
                    />
                    <delivered-csee
                      v-if="selectedOption == PANELS.DELIVEREDCSEE"
                      :id="item.id"
                      :bank-request-date="new Date(item.bankRequestDate)"
                      @on-cancel="toggleOpen(index)"
                      @on-saved="doSearch(index)"
                    />
                    <additional-info
                      v-if="selectedOption == PANELS.ADDITIONAL_INFO"
                      :item="item"
                    />
                    <bank-request
                      v-if="selectedOption == PANELS.BANKREQUEST"
                      :id="item.id"
                      @on-cancel="toggleOpen(index)"
                      @on-saved="doSearch(index)"
                    />
                    <return-card
                      v-if="selectedOption == PANELS.RETURN"
                      :id="item.id"
                      @on-cancel="toggleOpen(index)"
                      @on-saved="doSearch(index)"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </callout>
    </div>
    <pagination
      v-if="showPagination"
      :data="resultData.pagination"
      :page-size="15"
      :show-text="true"
      @pagination-go-page="onPageChange"
    />
  </div>
</template>

<script>
import Callout from 'custom-callout';
import DropDown from 'dropdown';
import CustomBalloon from 'custom-balloon';
import Pagination from 'pagination';
import CardManagementStatus from '@/utils/constants/CardManagementStatus';
import CancelCard from './CancelCard';
import DeliverCard from './DeliverCard';
import ReceivedCard from './ReceivedCard';
import SingleReceivedCard from './SingleReceivedCard';
import ClaimCard from './ClaimCard';
import CardManagement from './CardManagement';
import DocumentCard from './DocumentCard';

import AdditionalInfo from './AdditionalInfo';
import DeliveredCsee from './DeliveredCsee.vue';
import BankRequest from './BankRequest.vue';
import roles from '@/utils/constants/roles.js';
import ReturnCard from './ReturnCard';
import ArchiveCard from '@/views/scholarship/cardHandling/components/ArchiveCard.vue';

const PANELS = {
  CLAIM: 'CLAIM',
  RECEIVED: 'RECEIVED',
  SINGLE_RECEIVED: 'SINGLE_RECEIVED',
  DELIVER: 'DELIVER',
  CANCEL: 'CANCEL',
  MANAGEMENT: 'MANAGEMENT',
  DOCUMENTS: 'DOCUMENTS',
  ADDITIONAL_INFO: 'ADDITIONAL_INFO',
  DELIVEREDCSEE: 'DELIVEREDCSEE',
  BANKREQUEST: 'BANKREQUEST',
  RETURN: 'RETURN',
  ARCHIVE: 'ARCHIVE',
};

const ByClaimType = {
  PIN: 'P',
  Tarjeta: 'T',
};

export default {
  name: 'SearchResult',
  components: {
    ArchiveCard,
    Callout,
    CustomBalloon,
    DropDown,
    Pagination,
    CancelCard,
    DeliverCard,
    ReceivedCard,
    SingleReceivedCard,
    ClaimCard,
    CardManagement,
    DocumentCard,
    AdditionalInfo,
    DeliveredCsee,
    BankRequest,
    ReturnCard,
  },
  props: {
    resultData: {
      type: Object,
      default: () => ({
        data: [],
        pagination: {},
      }),
    },
  },
  data: () => ({
    PANELS,
    selectedOption: null,
    ByClaimType,
    CardManagementStatus,
  }),
  computed: {
    isAdminProvider() {
      return [
        roles.AdminProvider,
        roles.AdminProInfo,
        roles.Administrador,
      ].includes(this.userRole);
    },
    showDetails() {
      return (serviceName) => serviceName === 'Otros';
    },
    actionItems() {
      return (item) => [
        {
          name: 'claim',
          label: 'Reclamación',
          icon: 'fas fa-ticket-alt color-primary-1',
          visible: true,
          click: (item) => {
            this.openDetails(item, PANELS.CLAIM);
          },
          border: this.isReceptionActionVisible(item.status) ? 'bottom' : null,
        },
        {
          name: 'received',
          label: 'Recibida en SAEE',
          visible: this.isReceptionActionVisible(item.status),
          icon: 'fas fa-redo-alt color-primary-1',
          click: (item) => {
            this.openDetails(item, PANELS.RECEIVED);
          },
        },
        {
          name: 'delivered-csee',
          label: 'Entregada al CSEE',
          visible: this.isDeliveredCseeActionVisible(item.status),
          icon: 'fas fa-user-check color-primary-1',
          click: (item) => {
            this.openDetails(item, PANELS.DELIVEREDCSEE);
          },
        },
        {
          name: 'single-received',
          label: this.singleReceivedLabel(item.status),
          visible: this.isSingleReceptionActionVisible(item.status),
          icon: 'fas fa-redo-alt color-primary-1',
          click: (item) => {
            this.openDetails(item, PANELS.SINGLE_RECEIVED);
          },
        },
        {
          name: 'delivered',
          label: 'Entregada a Encargado',
          visible: this.isDeliverActionVisible(item.status),
          icon: 'fas fa-user-check color-primary-1',
          click: (item) => {
            this.openDetails(item, PANELS.DELIVER);
          },
          border: this.isArchiveActionVisible(item.status) ? '' : 'bottom',
        },
        {
          name: 'archive',
          label: 'Archivar',
          icon: 'fas fa-folder color-primary-1',
          visible: this.isArchiveActionVisible(item.status),
          click: (item) => {
            this.openDetails(item, PANELS.ARCHIVE);
          },
          border: 'bottom',
        },
        {
          name: 'cancel',
          label: 'Cancelar',
          icon: 'fas fa-times-circle color-red',
          visible: this.isCancelActionVisible(item.status),
          click: (item) => {
            this.openDetails(item, PANELS.CANCEL);
          },
        },
        {
          name: 'management',
          label: 'Gestión',
          icon: 'fa fa-file-search color-primary-1',
          click: (item) => {
            this.openDetails(item, PANELS.MANAGEMENT);
          },
        },
        {
          name: 'documents',
          label: 'Documentos',
          icon: 'fas fa-file-upload color-primary-1',
          click: (item) => {
            this.openDetails(item, PANELS.DOCUMENTS);
          },
        },
        {
          name: 'bankRequest',
          label: 'Solicitud al banco',
          icon: 'fa fa-credit-card-front color-primary-1',
          visible: this.isBankRequestVisible(item.status),
          click: (item) => {
            this.openDetails(item, PANELS.BANKREQUEST);
          },
        },
        {
          name: 'return',
          label: 'Devolución',
          icon: 'fas fa-redo-alt color-primary-1',
          visible: this.isReturnActionVisible(item.status),
          click: (item) => {
            this.openDetails(item, PANELS.RETURN);
          },
        },
      ];
    },
    isArchiveActionVisible() {
      return (status) =>
        (status.id === CardManagementStatus.RecibidaSAEE ||
          status.id === CardManagementStatus.EntregadaCSEE) &&
        this.userHasPermissions('provider.beca.archivecard');
    },
    isCancelActionVisible() {
      return (status) =>
        status.id !== CardManagementStatus.Nuevo &&
        status.id !== CardManagementStatus.Cancelada &&
        this.userHasPermissions('card.management.cancel');
    },
    isDeliverActionVisible() {
      return (status) =>
        status.id == CardManagementStatus.RecibidaSAEE ||
        status.id == CardManagementStatus.EntregadaCSEE ||
        status.id == CardManagementStatus.Archivada;
    },
    isClaimActionVisible() {
      return (status) => status.id == CardManagementStatus.Entregada;
    },
    isReceptionActionVisible() {
      return (status) => status.id == CardManagementStatus.SolicitadaBanco;
    },
    isDeliveredCseeActionVisible() {
      return (status) =>
        status.id == CardManagementStatus.RecibidaSAEE ||
        status.id == CardManagementStatus.Archivada;
    },
    isSingleReceptionActionVisible() {
      return (status) =>
        status.id == CardManagementStatus.RecibidaSAEENoPin ||
        status.id == CardManagementStatus.RecibidaSAEENoTarjeta;
    },
    isBankRequestVisible() {
      return (status) =>
        status.id == CardManagementStatus.Nuevo && this.isAdminProvider;
    },
    isClaimByPin() {
      return (item) =>
        (item.status.id == CardManagementStatus.Nuevo ||
          item.status.id == CardManagementStatus.SolicitadaBanco) &&
        item.generatedByClaimType == ByClaimType.PIN;
    },
    isReturnActionVisible() {
      return (status) =>
        status.id == CardManagementStatus.Entregada ||
        status.id == CardManagementStatus.EntregadaCSEE;
    },
    showPagination() {
      return (
        this.resultData.data.length > 0 &&
        this.resultData.pagination.totalItemCount >
          this.resultData.pagination.perPage
      );
    },
    singleReceivedLabel() {
      return (status) =>
        `Recibido de ${
          status.id == CardManagementStatus.RecibidaSAEENoPin
            ? 'PIN'
            : 'Tarjeta'
        }`;
    },
    getStudentFullName() {
      return (item) =>
        (item.student && item.student.replace(item.numSIE, '')) || '-';
    },
  },
  methods: {
    getColorStatus(status) {
      const statusColors = [
        'secondary-23',
        'secondary-38',
        'secondary-38',
        'green-light',
        'brown',
        'secondary-23',
        'secondary-38',
        'green-light',
        'secondary-23',
      ];
      return statusColors[Number(status.id) - 1];
    },
    onPageChange(page) {
      this.$emit('on-page-change', page);
    },
    openDetails(item, option) {
      if (
        (this.selectedOption !== option && !item.item.isOpen) ||
        this.selectedOption == option
      ) {
        this.toggleOpen(item.index);
      }
      this.selectedOption = option;
    },
    toggleOpen(index) {
      this.resultData.data = this.resultData.data.map((item, itemIndex) => {
        item.isOpen = index === itemIndex ? !item.isOpen : false;
        return item;
      });
    },
    doSearch(index) {
      this.toggleOpen(index);
      this.$emit('do-search');
    },
  },
};
</script>
<style scoped lang="scss">
@import '@/shared/scss/config/_colors.scss';

.balloon {
  padding: 6px;
  background: #fdfcf4 0% 0% no-repeat padding-box;
  border-radius: 20px;
  opacity: 1;
}
</style>
